import React from "react";
import "./Footer.css";

import logoFb from "../../assets/img/rrss/fb.svg";
import logoTwit from "../../assets/img/rrss/twitter.svg";
import logoTube from "../../assets/img/rrss/youtube.svg";
import logoInsta from "../../assets/img/rrss/insta.svg";
import logoSpoti from "../../assets/img/rrss/spotify.svg";

import logoTnc from "../../assets/img/TNCDigital2.869cc284.png"

import { Link } from "react-router-dom";

import CookieBot from "react-cookiebot";

function Footer(props) {

  const lang = props.lang;
  //etiquetas idiomas
  let terms,
    linkterms,
    priv,
    linkpriv,
    faqs,
    linkfaqs,
    cookies,
    linkcookies,
    contact,
    linkcontact = "";
  if (lang === "cat") {
    faqs = "Preguntes freqüents i tutorials";
    terms = "Avís legal";
    priv = "Política de privacitat";
    cookies = "Política de galetes";
    contact = "Contacte";
    linkterms = "https://www.tnc.cat/ca/avis-legal";
    linkpriv = "https://www.tnc.cat/ca/politica-privacitat";
    linkfaqs = "https://www.tnc.cat/ca/faqs-tncdigital";
    linkcookies = "https://www.tnc.cat/ca/cookies";
    linkcontact = "https://www.tnc.cat/ca/contacte-tnc";
  }
  if (lang === "esp") {
    faqs = "Preguntas frecuentes y tutoriales";
    terms = "Aviso legal";
    priv = "Política de privacidad";
    cookies = "Política de cookies";
    contact = "Contacto";
    linkterms = "https://www.tnc.cat/es/aviso-legal";
    linkpriv = "https://www.tnc.cat/es/politica-privacidad";
    linkfaqs = "https://www.tnc.cat/es/faqs-tncdigital";
    linkcookies = "https://www.tnc.cat/es/cookies";
    linkcontact = "https://www.tnc.cat/es/contacto-tnc";
  }
  if (lang === "eng") {
    faqs = "FAQ's and tutorials";
    terms = "Terms";
    priv = "Privacy policy";
    cookies = "Cookies policy";
    contact = "Contact";
    linkterms = "https://www.tnc.cat/en/legal-notice";
    linkpriv = "https://www.tnc.cat/en/privacy-policy";
    linkfaqs = "https://www.tnc.cat/en/faqs-tncdigital";
    linkcookies = "https://www.tnc.cat/en/cookies";
    linkcontact = "https://www.tnc.cat/en/tnc-contact";
  }
  const closeMobileMenu = () =>
  { 
    console.log("cerrar");
  }
  const domainGroupId = '007ce5a6-fd21-44bc-a151-afd5da475cfd';

  return (
   
    <>
     <CookieBot domainGroupId={domainGroupId} />
      <div className="footerTNC">
     { <script id="CookieDeclaration" src="https://consent.cookiebot.com/007ce5a6-fd21-44bc-a151-afd5da475cfd/cd.js" type="text/javascript" async></script> }
        <img tabindex="0"
          className="footer_logo"
          alt="TNC_logo"
          src={logoTnc}
          onClick={closeMobileMenu}
        />
     
        <nav className="footer_nav">
          <small className="footer_option">
            <a
              href={linkterms}
              className="footer_optionsmallneOne"
              target="_blank"
              rel="noopener noreferrer"
            >
              {terms}
            </a>
          </small>
          <small className="footer_option">
            <a
              href={linkpriv}
              className="footer_optionsmallneOne"
              target="_blank"
              rel="noopener noreferrer"
            >
              {priv}
            </a>
          </small>
          <small className="footer_option">
            <a
              href={linkcookies}
              className="footer_optionsmallneOne"
              target="_blank"
              rel="noopener noreferrer"
            >
              {cookies}
            </a>
          </small>
         { /*<small className="footer_option">
            <a
              href={linkfaqs}
              className="footer_optionsmallneOne"
              target="_blank"
              rel="noopener noreferrer"
            >
              {faqs}
            </a>
          </small>*/}
          <small className="footer_option">
            <a
              href={linkcontact}
              className="footer_optionsmallneOne"
              target="_blank"
              rel="noopener noreferrer"
            >
              {contact}
            </a>
          </small>
        </nav>
        <nav className="footer_nav_social">
          <a
            href="https://www.facebook.com/teatrenacionalcatalunya/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer_optionLineOne"
          >
            <img
              className="footer_option_social"
              alt="facebookLogo"
              src={logoFb}
            ></img>
          </a>
          <a
            href="https://twitter.com/teatrenacional"
            target="_blank"
            rel="noopener noreferrer"
            className="footer_optionLineOne"
          >
            <img
              className="footer_option_social"
              alt="twitter logo"
              src={logoTwit}
            ></img>
          </a>
          <a
            href="https://www.youtube.com/user/TeatreNacional"
            target="_blank"
            rel="noopener noreferrer"
            className="footer_optionLineOne"
          >
            <img
              className="footer_option_social"
              alt="logo youtube"
              src={logoTube}
            ></img>
          </a>
          <a
            href="https://www.instagram.com/teatrenacional/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer_optionLineOne"
          >
            <img
              className="footer_option_social"
              alt="logo instagram"
              src={logoInsta}
            ></img>
          </a>
          <a
            href="https://open.spotify.com/show/40dF84SJEjsGfQCW5FLq5j?si=2yUS0KimTJ2KJNB_gSWN1Q"
            target="_blank"
            rel="noopener noreferrer"
            className="footer_optionLineOne"
          >
            <img
              className="footer_option_social"
              alt="logo Spotify"
              src={logoSpoti}
            ></img>
          </a>
        </nav>
      </div>
    </>
  );
}

export default Footer;
